import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'

/**
 * Spys on the browser to determine the width of an element, and adds
 * appropriate classes to the element so CSS can respond to the size of
 * the element (e.g. display-small).
 */
var SizeSpy = Backbone.View.extend({

	// this.options.el the element to spy on
	// this.options.classes class names to apply based on the various size breakpoints
	// this.options.applyTo (optional) the element to apply the class to
	// this.options.breakpoints (optional) custom breakpoints to use

	breakpoints: [ 400, 590, 900 ],

	initialize: function(options) {
		this.options = options || {}
		this.breakpoints = options.breakpoints || this.breakpoints
		this.classes = options.classes
		this.applyTo = options.applyTo ? $(options.applyTo) : this.$el
	},

	spy: function(width) {
		width = width || this.$el.width()
		var clazz
		_.forEach(this.breakpoints, function(breakpoint, index) {
			if (width <= breakpoint) {
				clazz = this.classes[index]
				return false
			}
		}.bind(this))
		if (!clazz) {
			clazz = _.last(this.classes)
		}

		_.forEach(this.classes, this.applyTo.removeClass.bind(this.applyTo))
		this.applyTo.addClass(clazz)
	}

})

export default SizeSpy

SizeSpy.__filename__ = 'components/size-spy.js'
